window.activateAbSiv018 = () => {
	const uspsContainer = document.querySelector(".bs-ab-siv-018");
	if (!uspsContainer) return;

	uspsContainer.setAttribute("data-ab-siv-018", "true");

	// Wir messen die Zeit, die der Nutzer auf der Seite verbringt, bis der Tab geschlossen oder verlassen wird.
	const abSiv018StartTime = Date.now();

	const abSiv018SendDuration = (duration) => {
		window["ablyft"] = window["ablyft"] || [];
		window["ablyft"].push({
			eventType: "custom",
			eventName: "ab-siv-018-duration",
			eventValue: duration,
		});
	};

	// Wir benutzen 'visibilitychange' und 'beforeunload', um so genau wie möglich zu sein
	const abSiv018HandleLeave = () => {
		const duration = Math.floor((Date.now() - abSiv018StartTime) / 1000); // Sekunden
		abSiv018SendDuration(duration);
	};

	// Nur einmal senden
	let abSiv018HasSent = false;

	const abSiv018MaybeSend = () => {
		if (!abSiv018HasSent) {
			abSiv018HasSent = true;
			abSiv018HandleLeave();
		}
	};

	window.addEventListener("beforeunload", () => {
		abSiv018MaybeSend();
	});
};
